<template>
  <form @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-12">
        <b-checkbox v-model="informative.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-network-select
          v-model="informative.network_ids"
          :errors="errors.network_ids"
        ></app-network-select>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <b-field label="Data e Hora" required>
          <b-datetimepicker
            rounded
            v-model="informative.datetime"
            placeholder="Selecionar date e hora"
            icon="calendar-today"
            :datetime-formatter="bDateTimeFormatter"
            horizontal-time-picker
          ></b-datetimepicker>
        </b-field>
      </div>
      <div class="col-4">
        <app-input
          v-model="informative.title"
          label="Título"
          :errors="errors.title"
          maxlength="128"
          required
        ></app-input>
      </div>
      <div class="col-4">
        <app-input
          v-model="informative.headline"
          label="Chamada"
          :errors="errors.headline"
          maxlength="256"
          required
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <app-file-picker
          label="Imagem"
          flag="informative"
          v-model="imageToCrop"
          accept="image/*"
          :errors="errors.image"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="16 / 9"
          @croppedImage="onCropperImage"
        ></app-image-cropper>

        <img
          v-if="informative.image"
          :src="informative.image"
          alt="Imagem do Informativo"
          class="img-preview"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-field label="Texto" required>
          <editor
            v-model="informative.text"
            :errors="errors.text"
            api-key="8tcgv8vqclsf5uhooax65dbbp0d4lbw0yvulc2wjwha7a1dp"
            :init="{
              height: 300,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
            }"
          />
        </b-field>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import InformativeService from '@/services/informative.service';
import BuefyMixin from '@/mixins/BuefyMixin';
import Editor from '@tinymce/tinymce-vue';
import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';

import { required } from 'vuelidate/lib/validators';

import * as moment from 'moment';

export default {
  name: 'informatives-form',
  mixins: [BuefyMixin],
  props: ['id', 'errors', 'saving'],
  components: {
    Editor,
    AppImageCropper,
  },
  data: () => {
    return {
      imageToCrop: null,
      isLoading: true,
      informative: {
        active: true,
        title: null,
        headline: null,
        datetime: new Date(),
        text: null,
        image: null,
        network_ids: [],
      },
    };
  },
  validations: {
    informative: {
      title: { required },
      headline: { required },
      datetime: { required },
      text: { required },
      image: { required },
    },
  },
  methods: {
    loadInformative(id) {
      InformativeService.getId(id)
        .then(({ data: informative }) => {
          this.informative = {
            ...informative,
            datetime: new Date(informative.datetime),
          };
        })
        .catch(() => this.toastify('Erro ao carregar Notícia.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.informative,
        datetime: moment(this.informative.datetime).format('DD/MM/YYYY HH:mm'),
      });
    },
    onCropperImage(value) {
      this.informative.image = value;
      this.imageToCrop = '';
    },
  },
  beforeMount() {
    if (this.id) this.loadInformative(this.id);
    else this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.img-preview {
  max-height: 400px;
  object-fit: cover;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}
</style>
